import CrudSection from "./CrudSection";

const GRADES = Array.from({ length: 8 }, (_, i) => ({
  value: String(i + 1),
  label: `Grade ${i + 1}`,
}));

const SKILLS = [
  { value: "reading", label: "Reading Skills" },
  { value: "grammar", label: "Grammar" },
  { value: "writing", label: "Writing Skills" },
  { value: "vocabulary", label: "Vocabulary" },
];

const COLORS = [
  { value: "purple", label: "Purple" },
  { value: "blue", label: "Blue" },
  { value: "green", label: "Green" },
  { value: "lavender", label: "Lavender" },
  { value: "navy", label: "Navy (dark)" },
];

const FIELDS = [
  { name: "title", label: "Title", type: "text", full: true, placeholder: "e.g. Nouns Practice — Set 1" },
  { name: "grade", label: "Grade", type: "select", options: [{ value: "", label: "Choose grade…" }, ...GRADES] },
  { name: "skill", label: "Skill area", type: "select", options: [{ value: "", label: "Choose skill…" }, ...SKILLS] },
  { name: "pages", label: "Pages", type: "number" },
  { name: "pdf_url", label: "PDF URL", type: "text", full: true, placeholder: "https://…/worksheet.pdf" },
  { name: "color", label: "Card color", type: "select", options: COLORS },
  { name: "order", label: "Order", type: "number" },
  { name: "active", label: "Active", type: "checkbox", placeholder: "Show on website" },
];

const SKILL_LABEL = Object.fromEntries(SKILLS.map((s) => [s.value, s.label]));

export default function AdminWorksheets() {
  return (
    <CrudSection
      title="Worksheets"
      endpoint="worksheets"
      testIdPrefix="worksheet"
      fields={FIELDS}
      defaultValues={{ active: true, order: 0, pages: 0, color: "purple", grade: "", skill: "" }}
      renderRow={(w) => (
        <div>
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <h3 className="font-display font-bold text-base text-[#1F2547]">
              {w.title}
            </h3>
            {w.grade && (
              <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#C7DCF7] text-[#1F2547]">
                Grade {w.grade}
              </span>
            )}
            {w.skill && (
              <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#D4EDDB] text-[#1F2547]">
                {SKILL_LABEL[w.skill] || w.skill}
              </span>
            )}
            {!w.active && (
              <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-red-50 text-red-600">
                Hidden
              </span>
            )}
          </div>
          <div className="text-xs text-[#5B6079] font-medium">
            {w.pages || 0} pages · {w.pdf_url ? "PDF linked" : "No PDF yet"}
          </div>
        </div>
      )}
    />
  );
}
